import { getUor } from 'store/selectors'

export const customerTheme = (state) => {
  switch (getUor(state)) {
    case 735:
    case '735':
    case 2885:
    case '2885':
      return 'vinci'
    case 620:
    case '620':
      return 'stef'
    default:
      return ''
  }
}
